import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { ChevronUpSolidIcon, ChevronDownSolidIcon } from '@compono/ui-icons';
import { renderProp } from '../utils/renderProp.js';
import { DropdownButton } from '../Dropdown/DropdownButton.js';
import { useDropdownContext } from '../Dropdown/DropdownProvider.js';
import { useSelectLegacyContext } from './SelectLegacyProvider.js';
import { Box } from '../Box/index.js';

var SelectLegacyDropdownButton = function (_a) {
    var children = _a.children; _a.sx; var size = _a.size, props = __rest(_a, ["children", "sx", "size"]);
    var isOpen = useDropdownContext().isOpen;
    var selectContext = useSelectLegacyContext();
    return (jsx(DropdownButton, __assign({ themeKey: "selectButton", "data-is-open": isOpen, size: selectContext.size || size }, props, { children: jsxs(Box, __assign({ sx: {
                display: "flex",
                width: "100%",
                alignItems: "center",
                textAlign: "left",
            } }, { children: [jsx(Box, __assign({ sx: {
                        flex: 1,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    } }, { children: renderProp({
                        prop: children,
                        context: selectContext,
                        fallback: selectContext.label || jsx("div", {}),
                    }) })), jsx(Box, __assign({ sx: { display: "flex", ml: "0.5rem", alignItems: "center" } }, { children: isOpen ? jsx(ChevronUpSolidIcon, {}) : jsx(ChevronDownSolidIcon, {}) }))] })) })));
};

export { SelectLegacyDropdownButton };
//# sourceMappingURL=SelectLegacyDropdownButton.js.map
